import { get, post } from "../request.js";

export const ApiGetChildInfo = {
  get: (email) => {
    return get(`/parent/getchildren/${email}`);
  },
};
export const ApiGetLearnDashboard = {
  get: (email, stuID, courseID) => {
    return get(`/parent/dashboard/${email}/${stuID}/${courseID}`);
  },
};

export const ApiSetAward = {
  get: (stuID, taskID, star) => {
    return get(`/parent/setaward/${stuID}/${taskID}/${star}`);
  },
};
export const ApiGetLearnRecording = {
  get: (voiceID) => {
    return get(`/utility/getvoice/${voiceID}`);
  },
};

export const ApiSetImgPw = {
  post: (sid, imgpw) => {
    return post(`/parent/setimgpw/${sid}`, imgpw);
  },
};

export const ApiRegisterParent = {
  post: (lang, data) => {
    return post(`/register/parent/${lang}`, data);
  },
};

export const ApiRegisterParentVerify = {
  post: (data) => {
    return post(`/register/parent/verify`, data);
  },
};

export const ApiParentLoginVerify = {
  post: (data) => {
    return post(`/parent_login/verify`, data);
  },
};

export const ApiForgetPassword = {
  get: (email, lang) => {
    return get(`/forgotpw/${email}/${lang}`);
  },
};

export const ApiResetPassword = {
  post: (data) => {
    return post(`/reset-password-with-code`, data);
  },
};

export const ApiGetUserSubscriptions = {
  get: (studentId) => {
    // return get(
    //   `/api/subscription/user/STU-CccXzbjJAvqVKn693FFDwZ/subscriptions`
    // );
    return get(`/api/subscription/user/${studentId}/subscriptions`);
  },
};
